module.exports = __webpack_public_path__ + "img/form@2x.9b46945.jpg";